import React, { useEffect, useState } from 'react'
import {
  Navbar,
  Nav,
  Container,
  Button,
  Collapse,
  Offcanvas,
  Badge,
} from 'react-bootstrap'
import {
  Bell,
  People,
  PersonPlus,
  List,
  Person,
  Book,
  ClipboardCheck,
  CalendarCheck,
  Building,
  ChevronDown,
  ChevronUp,
  BoxArrowRight,
  ChatDots,
  CreditCard,
  PersonBadge,
  FileEarmarkText,
  Award,
  ClipboardData,
  CurrencyRupee,
  Briefcase,
  QuestionCircle,
} from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import {
  FaArchive,
  FaClipboardList,
  FaCog,
  FaExchangeAlt,
  FaExclamationTriangle,
  FaEye,
  FaFileInvoice,
  FaLock,
  FaPenAlt,
  FaTachometerAlt,
  FaUnlockAlt,
  FaUser,
  FaUserMinus,
  FaUserShield,
  FaUserSlash,
} from 'react-icons/fa'

import {
  FaBook,
  FaBookOpen,
  FaChalkboard,
  FaChalkboardTeacher,
  FaUniversity,
  FaUserTie,
  FaGraduationCap,
} from 'react-icons/fa'
import Cookies from 'js-cookie'
import { useAuth } from './AuthContext'
import { Settings } from 'react-feather'
import NewInstituteSelectionModal from './NewInstituteSelectionModal'

export default function Sidenavbar() {
  const [openDropdown, setOpenDropdown] = useState('')
  const [instituteName, setinstituteName] = useState('')
  const [show, setShow] = useState(false)
  const [notifications, setNotifications] = useState(3)
  const [user, setUser] = useState(null) // ✅ Set default value to `null`
  const { logout } = useAuth()
  const [showModal, setShowModal] = useState(false);
  const [selectedInstituteId, setSelectedInstituteId] = useState(0); // your current logic

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    const userLogged = Cookies.get('user')
    console.log('userLogged', userLogged)
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user') // ✅ Remove invalid cookie
      }
    }
  }, [])
  useEffect(()=>{
    const institute_name = Cookies.get("institute_name")
    setinstituteName(institute_name)
  },[])

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? '' : dropdown)
  }
  // const { user } = useAuth()
  // console.log('User Data are : ', user)

  return (
    <>
      <Navbar
        expand="lg"
        className="d-lg-none bg-primary shadow-sm fixed-top navbar-dark"
      >
        <Container>
          <Navbar.Toggle
            onClick={() => setShow(true)}
            style={{
              top: '10px',
              left: '10px',
              zIndex: '1050',
              boxShadow: 'none',
              width: show ? '200px' : 'auto',
              height: 'auto',
            }}
          />

          <Offcanvas
            show={show}
            onHide={() => setShow(false)}
            placement="start"
            className="bg-light no-print"
            backdrop={false}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="fw-bold text-primary" style={{fontSize:"16px"}}>
                🎓 {instituteName}
            
              </Offcanvas.Title>
              
          
            </Offcanvas.Header>
                    {(user?.user_type !== 'teacher' && user?.user_type !== "parents") && (
                     <div className="d-flex justify-content-start ps-3 pt-2">
                      <Button
                        variant="link"  
                        style={{marginTop:"-1rem"}}
                         onClick={handleOpenModal}
                        className="ms-0  p-0 btn btn-link link-primary text-decoration-none justify-content-start no-print"
 
                      >
                      <span style={{
                          fontSize:"16px"
                        }}>  [ <FaExchangeAlt /> Switch Institute]</span>
                      </Button>
                      </div>
  )}
            <Offcanvas.Body className="d-flex flex-column justify-content-between h-100">
              <Nav className="flex-column w-75">
                {(user?.user_type !== 'teacher' && user?.user_type !=="parents") && (
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-3"
                    onClick={() => (window.location.href = '/Dashboard')}
                  >
                    <div className="d-flex align-items-center">
                      <FaTachometerAlt size={20} className="me-2" />
                      <span>Dashboard</span>
                    </div>
                  </Button>
             )} 

                {(user?.user_type !=="parents" && user?.user_type !=="teacher" )&& (
                  <>
                  
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('students')}
                >
                  <span>
                    <People size={20} className="me-2" /> Students
                  </span>
                  {openDropdown === 'students' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'students'}>
                  <div>
                    <Link
                      to="/AddStudent"
                      className="nav-link text-dark ps-4"
                      onClick={() => setShow(false)}
                    >
                      <People
                        size={16}
                        className="me-2"
                        style={{ verticalAlign: 'middle' }}
                      />
                      Student List
                    </Link>
                    {user?.user_type !== 'teacher' && (
                      <Link
                        to="/DischargedStudent"
                        className="nav-link text-dark ps-4"
                        onClick={() => setShow(false)}
                      >
                        <FaUserSlash /> Left Student
                      </Link>
                    )}
                  </div>
                </Collapse>
                </>
                )}

                
                {user?.user_type ==="teacher"&& (
                  <>
                  
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('students')}
                >
                  <span>
                    <People size={20} className="me-2" /> Students
                  </span>
                  {openDropdown === 'students' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'students'}>
                  <div>
                    <Link
                      to="/TeacherStudent"
                      className="nav-link text-dark ps-4"
                      onClick={() => setShow(false)}
                    >
                      <People
                        size={16}
                        className="me-2"
                        style={{ verticalAlign: 'middle' }}
                      />
                      Student List
                    </Link>
                    {user?.user_type !== 'teacher' && (
                      <Link
                        to="/DischargedStudent"
                        className="nav-link text-dark ps-4"
                        onClick={() => setShow(false)}
                      >
                        <FaUserSlash /> Left Student
                      </Link>
                    )}
                  </div>
                </Collapse>
                </>
                )}

                {/* Course List Dropdown */}
                {(user?.user_type !== 'teacher' && user?.user_type !=="parents") && (
                  <>
                    <Button
                      variant="light"
                      className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                      onClick={() => toggleDropdown('courseList')}
                    >
                      <span>
                        <FaBookOpen size={20} className="me-2" /> Course
                      </span>
                      {openDropdown === 'courseList' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'courseList'}>
                      <div>
                        <Link
                          to="/AddCourse"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <FaBookOpen size={18} className="me-2" /> Course List
                        </Link>
                        <Link
                          to="/AddSubject"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <FaBookOpen size={18} className="me-2" /> Subject
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                { user?.user_type !=="parents" && (
                  <>
                {/* Classes Dropdown */}
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('classes')}
                >
                  <span>
                    <FaChalkboard size={20} className="me-2" /> Classes
                  </span>
                  {openDropdown === 'classes' ? <ChevronUp /> : <ChevronDown />}
              
                </Button>
                <Collapse in={openDropdown === 'classes'}>
                  <div>
                    <Link
                      to="/AddClass"
                      className="nav-link text-dark ps-4"
                      onClick={() => setShow(false)}
                    >
                      <FaChalkboard size={18} className="me-2" /> Class List
                    </Link>
                  </div>
                </Collapse>
                </>
                )}
                {(user?.user_type !== 'teacher'  && user?.user_type !=="parents") && (
                  <>
                    <Button
                      variant="light"
                      className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                      onClick={() => toggleDropdown('feesManagement')}
                    >
                      <span>
                        <CreditCard size={20} className="me-2" /> Fees
                        Management
                      </span>
                      {openDropdown === 'feesManagement' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'feesManagement'}>
                      <div>
                        <Link
                          to="/FeeStructure"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <CreditCard size={18} className="me-2" /> Fees
                          Structure
                        </Link>
                        <Link
                          to="/ApplyFees"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <CreditCard size={18} className="me-2" />
                          Apply Fee
                        </Link>
                        <Link
                          to="/TakeFees"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <CurrencyRupee size={18} className="me-2" /> Take Fees
                        </Link>
                        <Link
                          to="/ManageStudentFees"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <CurrencyRupee size={18} className="me-2" /> Fees
                          Status
                        </Link>
                        <Link
                          to="/FeeCollection"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <CurrencyRupee size={18} className="me-2" /> Fees
                          Collection
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}


                
                {user?.user_type === 'parents' && ( 
                   <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    onClick={() => (window.location.href = '/Student/List')}
                  >
                    <div className="d-flex align-items-center">
                      <FaUser size={20} className="me-2" />
                      <span>Student's Profile</span>
                    </div>
                  </Button> 
               )} 
                {(user?.user_type !== 'teacher' && user?.user_type !=="parents") && (
                  <>
                    <Button
                      variant="light"
                      className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                      onClick={() => toggleDropdown('institute')}
                    >
                      <span>
                        <FaUniversity size={20} className="me-2" /> Institute
                      </span>
                      {openDropdown === 'institute' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'institute'}>
                      <div>
                        <Link
                          to="/AddInstitute"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <FaUniversity size={18} className="me-2" /> Institute
                          List
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                {/* Attendance Dropdown */}
                 {(user?.user_type !== 'teacher' && user?.user_type !== 'parents') && (
                  <>
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('attendance')}
                >
                  <span>
                    <ClipboardCheck size={20} className="me-2" /> Attendance
                  </span>
                  {openDropdown === 'attendance' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'attendance'}>
                  <div>
                    <Link
                      to="/TakeAttendance"
                      className="nav-link text-dark ps-4"
                      onClick={() => setShow(false)}
                    >
                      <CalendarCheck size={18} className="me-2" /> Take
                      Attendance
                    </Link>
                    <Link
                      to="/ViewAttendance"
                      className="nav-link text-dark ps-4"
                      onClick={() => setShow(false)}
                    >
                      <FaEye size={18} className="me-2" /> View Attendance
                    </Link>
                  </div>
                </Collapse>
                  </>
                )}


                  {(user?.user_type !== 'teacher' && user?.user_type !=="parents") && (
                  <>
                    <Button
                      variant="light"
                      className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                      onClick={() => toggleDropdown('teacher')}
                    >
                      <span>
                        <FaChalkboardTeacher size={20} className="me-2" /> Teacher
                      </span>
                      {openDropdown === 'teacher' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'teacher'}>
                      <div>
                        <Link
                          to="/TeacherList"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <FaChalkboardTeacher size={18} className="me-2" /> Teacher
                          List
                        </Link>
                         <Link
                        to="/AssignClass"
                         className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                      >
                        <FaUserTie size={18} className="me-2" />
                        Class Assign
                      </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                {/* Attendance Dropdown */}
                {(user?.user_type !== 'teacher' && user?.user_type !== 'parents') && (
                  <>
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('user')}
                >
                  <span>
                    <FaUser size={20} className="me-2" /> User
                  </span>
                  {openDropdown === 'user' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'user'}>
                  <div>
                    <Link
                      to="/AddUser"
                      className="nav-link text-dark ps-4"
                      onClick={() => setShow(false)}
                    >
                      <People size={18} className="me-2" /> User List
                    </Link>
                   </div>
                </Collapse>
                  </>
                )}


                {/* <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('teacher')}
                >
                  <span>
                    <FaChalkboardTeacher size={20} className="me-2" /> Teacher
                  </span>
                  {openDropdown === 'teacher' ? <ChevronUp /> : <ChevronDown />}
                </Button>
                <Collapse in={openDropdown === 'teacher'}>
                  <div>
                    {user?.user_type !== 'teacher' && (
                      <Link
                        to="/TeacherList"
                        className="nav-link text-dark ps-4"
                        onClick={() => setShow(false)}
                      >
                        <FaUserTie size={18} className="me-2" /> Teacher List
                      </Link>
                    )}
                    <Link
                      to="/AssignClass"
                      className="nav-link text-dark ps-4"
                      onClick={() => setShow(false)}
                    >
                      <FaUserTie size={18} className="me-2" /> Class Assign
                    </Link>
                  </div>
                </Collapse> */}

              {/* {(user?.user_type !== 'teacher' && user?.user_type !=="parents")  && (
                <>
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('guardian')}
                  >
                    <span>
                      <FaUser size={20} className="me-2" /> Guardian
                    </span>
                    {openDropdown === 'guardian' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'guardian'}>
                    <div>
                      <Link
                        to="/AddGuardian"
                          className="nav-link text-dark ps-4"
                        onClick={() => setShow(false)}
                      >
                        <FaUser size={18} className="me-2" />
                        Guardians
                      </Link>
                    </div>
                  </Collapse>
                </>
              )} */}

                {(user?.user_type !== 'teacher' && user?.user_type !=="parents") && (
                  <>
                    <Button
                      variant="light"
                      className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                      onClick={() => toggleDropdown('enquiry')}
                    >
                      <span>
                        <ChatDots size={20} className="me-2" /> Enquiry
                      </span>
                      {openDropdown === 'enquiry' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'enquiry'}>
                      <div>
                        <Link
                          to="/EnquiryForm"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <ChatDots size={18} className="me-2" /> Enquiry Form
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                {(user?.user_type === 'teacher' && user?.user_type !=="parents") && (
                  <>
                    <Button
                      variant="light"
                      className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                      onClick={() => toggleDropdown('examMarksheet')}
                    >
                      <span>
                        <FaPenAlt size={20} className="me-2" /> Exam Management
                      </span>
                      {openDropdown === 'examMarksheet' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'examMarksheet'}>
                      <div>
                         {user?.user_type !== 'teacher' && (
                          <>              
                          <Link
                          to="/ExamSheet"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <FaClipboardList size={18} className="me-2" /> Exams
                        </Link>
                        <Link
                          to="/ExamMarksheet"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <FaFileInvoice size={18} className="me-2" /> View
                          Marksheet
                        </Link>
                        </>
                         )}
                        {user?.user_type === 'teacher' && (
                          <Link
                          to="/AddExamResult"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <FaGraduationCap size={18} className="me-2" /> Create
                          Marksheet
                        </Link>
                        )}
                        
                        '
                      </div>
                    </Collapse>
                  </>
                )}

                {user?.user_type === 'teacher' && (
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start justify-content-between align-items-center py-2 text-decoration-none"
                    onClick={() => (window.location.href = '/ChangePassword')}
                  >
                    <div className="d-flex align-items-center">
                      <FaUnlockAlt size={20} className="me-2" /> Change Password
                    </div>
                  </Button>
                )}


                  {/* Certificate Dropdown */}
                  {(user?.user_type !=="parents" && user?.user_type !=="teacher") && (
                    <>
                    
              <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown('certificate')}
              >
                <span>
                  <Award size={20} className="me-2" /> Certificate
                </span>
                {openDropdown === 'certificate' ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </Button>
              <Collapse in={openDropdown === 'certificate'}>
                <div>
                  <Link
                    to="/Certificate"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                    onClick={()=>setShow(false)}
                  >
                    <Award size={18} className="me-2" /> Generate Certificate
                  </Link>
                   {/* <Link
                    to="/Transfer/Certificate"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <Award size={18} className="me-2" /> Generate TC
                  </Link> */}
                </div>
              </Collapse>
                    </>
                  )}

                {(user?.user_type !== 'teacher'  && user?.user_type !=="parents") && (
                  <>
                    <Button
                      variant="light"
                      className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                      onClick={() => toggleDropdown('settings')}
                    >
                      <span>
                        <Settings size={20} className="me-2" /> Settings
                      </span>
                      {openDropdown === 'settings' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'settings'}>
                      <div>
                        <Link
                          to="/settings"
                          className="nav-link text-dark ps-4"
                          onClick={() => setShow(false)}
                        >
                          <Settings size={18} className="me-2" /> Settings
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                 {user?.user_type === "parents" && (
                  <>
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('support')}
                  >
                    <span>
                      <QuestionCircle size={20} className="me-2" /> Support
                    </span>
                    {openDropdown === 'support' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'support'}>
                    <div>
                      <Link
                        to="/Raise-Query"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                        onClick={()=>setShow(false)}
                      >
                        <QuestionCircle size={18} className="me-2" />
                        Raise Query
                      </Link>
                    </div>
                  </Collapse>
                  </>
                  )}
                  {/* Parent Portal */}
 
                     {/* {user?.user_type !== 'parent' && ( 
                   <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    onClick={() => (window.location.href = '/Student/List')}
                  >
                    <div className="d-flex align-items-center">
                      <FaUser size={20} className="me-2" />
                      <span>Profile</span>
                    </div>
                  </Button> 
               )}  */}

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    onClick={() => (window.location.href = '/Student/Attendance')}
                  >
                    <div className="d-flex align-items-center">
                      <CalendarCheck size={20} className="me-2" />
                      <span>Attendance</span>
                    </div>
                  </Button> */}
                {/* )} */}

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    onClick={() => (window.location.href = '/Student/Fees')}
                  >
                    <div className="d-flex align-items-center">
                      <CurrencyRupee size={20} className="me-2" />
                      <span>Fees</span>
                    </div>
                  </Button> */}
                {/* )} */}

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    onClick={() => (window.location.href = '/Student/Course')}
                  >
                    <div className="d-flex align-items-center">
                      <FaBookOpen size={20} className="me-2" />
                      <span>Course</span>
                    </div>
                  </Button> */}
                {/* )} */}
           
              </Nav>

              {/* Login Button */}
              <Button
                // as={Link}
                // to="/LoginSignup"
                variant="primary"
                className="w-100 mt-auto"
                // onClick={() => setShow(false)}
                onClick={() => {
                console.log('Logout button clicked')

                logout()
              }}
                style={{ marginBottom: '4rem' }}
              >
                <BoxArrowRight size={20} className="me-2" /> Logout
              </Button>
            </Offcanvas.Body>
          </Offcanvas>
        </Container>
      </Navbar>

      {/* Sidebar for Desktop View */}
      <div
        className="d-none d-lg-flex w-auto overflow-auto"
        style={{ minHeight: '100vh' }}
      >
        <Navbar
          bg="white"
          variant="light"
          expand="lg"
          className="flex-column p-4  shadow w-auto"
          style={{
            width: '270px',
            height: '100vh',
            overflowY: 'auto', // Allow scrolling
            position: 'fixed',
            top: 0,
            left: 0,
            background: '#f8f9fa',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <Container className="d-flex flex-column h-70 text-center">
            <img
              src="/tta_logo.jpg"
              alt="Logo"
              style={{
                height: '170px',
                objectFit: 'contain',
                marginTop: '-10px',
                marginBottom: '10px',
              }}
            />
          
          
               
          <div
  style={{
    width: '100%',       // ensure it does not exceed sidebar width
    // padding: '0 8px',    // some horizontal padding
    textAlign: 'start',
  }}
>
  <p
    className="text-primary mb-2"
    style={{
      fontSize: '0.6rem',
      fontWeight: '500',
      margin: 0,
      overflowWrap: 'break-word', // break long words
      wordBreak: 'break-word',
      display: '-webkit-box',
      WebkitLineClamp: 3,        // limit to 3 lines
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textAlign: 'start',
    }}
    title={instituteName}       // full name on hover
  >
    🎓 {instituteName?.length > 40 
        ? `${instituteName.slice(0, 40)}...` 
        : instituteName}
  </p>
  {(user?.user_type !== 'teacher' && user?.user_type !== "parents") && (
                      <Button
                        variant="link"  
                        style={{marginTop:"-1rem"}}
                         onClick={handleOpenModal}
                        className="ms-0 p-0 btn btn-link link-primary text-decoration-none justify-content-end no-print"
 
                      >
                      <span style={{
                          fontSize:"12px"
                        }}>  [ <FaExchangeAlt /> Switch Institute ]</span>
                      </Button>
  )}
                      {showModal &&
                      <NewInstituteSelectionModal show={showModal} onClose={handleCloseModal} />}
              </div>


            <Nav className="flex-column w-100">
              {(user?.user_type !== 'teacher' && user?.user_type !== "parents") && (
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-3"
                  onClick={() => (window.location.href = '/Dashboard')}
                >
                  <div className="d-flex align-items-center">
                    <FaTachometerAlt size={20} className="me-2" />
                    <span>Dashboard</span>
                  </div>
                </Button>
              )}

              {/* Students Dropdown */}
              {(user?.user_type !== "parents" &&  user?.user_type !=="teacher") && (
                <>
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('students')}
                >
                  <span>
                    <People size={20} className="me-2" /> Students
                  </span>
                  {openDropdown === 'students' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'students'}>
                  <div>
                    {/* <Link to="/AddStudent" className="nav-link text-dark ps-4">
                    <PersonPlus size={18} className="me-2" /> Add Student
                  </Link> */}

                    <Link
                      to="/AddStudent"
                      className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                    >
                      <People
                        size={16}
                        className="me-2"
                        style={{ verticalAlign: 'middle' }}
                      />
                      <span style={{ verticalAlign: 'middle' }}>
                        Student List
                      </span>
                    </Link>
                    {user?.user_type !== 'teacher' && (
                      <Link
                        to="/DischargedStudent"
                        className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <span style={{ verticalAlign: 'middle' }}>
                          <FaUserSlash /> Left Students
                        </span>
                      </Link>
                    )}
                  </div>
                </Collapse>
                </>
              )}

 {user?.user_type === "teacher" && (
                <>
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                  onClick={() => toggleDropdown('teacherstudents')}
                >
                  <span>
                    <People size={20} className="me-2" /> Students
                  </span>
                  {openDropdown === 'teacherstudents' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'teacherstudents'}>
                  <div>
                    {/* <Link to="/AddStudent" className="nav-link text-dark ps-4">
                    <PersonPlus size={18} className="me-2" /> Add Student
                  </Link> */}

                    <Link
                      to="/TeacherStudent"
                      className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                    >
                      <People
                        size={16}
                        className="me-2"
                        style={{ verticalAlign: 'middle' }}
                      />
                      <span style={{ verticalAlign: 'middle' }}>
                        Student List
                      </span>
                    </Link>
                    {user?.user_type !== 'teacher' && (
                      <Link
                        to="/DischargedStudent"
                        className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <span style={{ verticalAlign: 'middle' }}>
                          <FaUserSlash /> Left Students
                        </span>
                      </Link>
                    )}
                  </div>
                </Collapse>
                </>
              )}
              {(user?.user_type !== 'teacher' && user?.user_type !== "parents")&& (
                <>
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('courseList')}
                  >
                    <span>
                      <FaBookOpen size={20} className="me-2" /> Course
                    </span>
                    {openDropdown === 'courseList' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>

                  <Collapse in={openDropdown === 'courseList'}>
                    <div>
                      <Link
                        to="/AddCourse"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <FaBookOpen size={18} className="me-2" /> Course List
                      </Link>
                      <Link
                        to="/AddSubject"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <FaBookOpen size={18} className="me-2" /> Subject
                      </Link>
                    </div>
                  </Collapse>
                </>
              )}

              {/* Classes Dropdown */}
              {user?.user_type !== "parents"&& (
                <>
                     <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown('classes')}
              >
                <span>
                  <FaChalkboard size={20} className="me-2" /> Classes
                </span>
                {openDropdown === 'classes' ? <ChevronUp /> : <ChevronDown />}
              </Button>
              <Collapse in={openDropdown === 'classes'}>
                <div>
                  <Link
                    to="/AddClass"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <FaChalkboard size={18} className="me-2" />
                    Class List
                  </Link>
                </div>
              </Collapse>

</>
              )}
         
              {/* Fees Dropdown */}

              {(user?.user_type !== 'teacher' && user?.user_type !== 'parents') && (
                <>
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('feesManagement')}
                  >
                    <span>
                      <CreditCard size={20} className="me-2" /> Fees Management
                    </span>
                    {openDropdown === 'feesManagement' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>

                  <Collapse in={openDropdown === 'feesManagement'}>
                    <div>
                      <Link
                        to="/FeeStructure"
                        className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <CreditCard size={18} className="me-2" /> Fee Structure
                      </Link>
                      <Link
                        to="/ApplyFees"
                        className="nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <CreditCard size={18} className="me-2" /> Apply Fee
                      </Link>

                      <Link
                        to="/TakeFees"
                        className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <CurrencyRupee size={18} className="me-2" />
                        Take Fees
                      </Link>
                      <Link
                        to="/ManageStudentFees"
                        className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <CurrencyRupee size={18} className="me-2" />
                        Fees Status{' '}
                      </Link>

                      <Link
                        to="/FeeCollection"
                        className="nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <CurrencyRupee size={18} className="me-2" />
                        Fee Collection
                      </Link>
                    </div>
                  </Collapse>
                </>
              )}

              {/* Institute Dropdown */}
              {(user?.user_type !== 'teacher' && user?.user_type !=="parents")  && (
                <>
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('institute')}
                  >
                    <span>
                      <FaUniversity size={20} className="me-2" /> Institute
                    </span>
                    {openDropdown === 'institute' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'institute'}>
                    <div>
                      <Link
                        to="/AddInstitute"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <FaUniversity size={18} className="me-2" />
                        Institute List
                      </Link>
                    </div>
                  </Collapse>
                </>
              )}

              {/* Admin Attendance Dropdown */}
              {user?.user_type !=="parents" && (
<>

<Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown('attendance')}
              >
                <span>
                  <ClipboardCheck size={20} className="me-2" /> Attendance
                </span>
                {openDropdown === 'attendance' ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </Button>
              <Collapse in={openDropdown === 'attendance'}>
                <div>
                  <Link
                    to="/TakeAttendance"
                    className="nav-link text-dark ps-4"
                  >
                    <CalendarCheck size={18} className="me-2" /> Take Attendance
                  </Link>
                  <Link
                    to="/ViewAttendance"
                    className="nav-link text-dark ps-4"
                  >
                    <FaEye /> View Attendance
                  </Link>
                </div>
              </Collapse>
              </>
              )}
              

              
              {/* Fees Dropdown */}
              {/* <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown("fees")}
              >
                <span>
                  <CurrencyRupee size={20} className="me-2" />
                  Fees
                </span>
                {openDropdown === "fees" ? <ChevronUp /> : <ChevronDown />}
              </Button>
              <Collapse in={openDropdown === "fees"}>
                <div>
                  <Link
                    to="/TakeFees"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <CurrencyRupee size={18} className="me-2" />
                    Take Fees
                  </Link>
                </div>
              </Collapse> */}

              {/* Teacher Dropdown */}

              {/* {user?.user_type !== 'teacher' && ( */}
                {user?.user_type !== "parents" && (
                  <>
                  
              <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown('teacher')}
              >
                <span>
                  <FaChalkboardTeacher size={20} className="me-2" />
                  Teacher
                </span>
                {openDropdown === 'teacher' ? <ChevronUp /> : <ChevronDown />}
              </Button>
              <Collapse in={openDropdown === 'teacher'}>
                <div>
                  {user?.user_type !== 'teacher' && (
                    <Link
                      to="/TeacherList"
                      className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                    >
                      <FaChalkboardTeacher size={18} className="me-2" />
                      Teacher List
                    </Link>
                  )}

                  <Link
                    to="/AssignClass"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <FaUserTie size={18} className="me-2" />
                    Class Assign
                  </Link>
                </div>
              </Collapse>
              </>
                )}

    {(user?.user_type !== 'teacher' && user?.user_type !== 'parents') && (
                  <>
                     <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown('user')}
              >
                <span>
                  <FaUser size={20} className="me-2" />
                  User
                </span>
                {openDropdown === 'user' ? <ChevronUp /> : <ChevronDown />}
              </Button>
                    <Collapse in={openDropdown === 'user'}>
                      <div>
                        <Link 
                        to="/AddUser"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center">
                          <People size={18} className="me-2" />
                          User List
                        </Link>
                      </div>
                    </Collapse>
               </>
                           )}
                
                {/* Guardian Dropdown */}
              {/* {(user?.user_type !== 'teacher' && user?.user_type !=="parents")  && (
                <>
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('guardian')}
                  >
                    <span>
                      <FaUser size={20} className="me-2" /> Guardian
                    </span>
                    {openDropdown === 'guardian' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'guardian'}>
                    <div>
                      <Link
                        to="/AddGuardian"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <FaUser size={18} className="me-2" />
                        Guardians
                      </Link>
                    </div>
                  </Collapse>
                </>
              )} */}

              {/* )} */}

              {/* <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown("examsheet")}
              >
                <span>
                  <FaChalkboardTeacher size={20} className="me-2" />
                  Exam Sheet
                </span>
                {openDropdown === "examsheet" ? <ChevronUp /> : <ChevronDown />}
              </Button>
              <Collapse in={openDropdown === "examsheet"}>
              <div>
                  <Link
                    to="/TeacherList"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <FaUserTie size={18} className="me-2" />
                    Exam Sheet
                  </Link>
                </div>
              </Collapse> */}

              {(user?.user_type !== 'teacher' &&  user?.user_type !== 'parents') && (
                <>
                  {/* Enquiry Dropdown */}
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('enquiry')}
                  >
                    <span>
                      <ChatDots size={20} className="me-2" /> Enquiry
                    </span>
                    {openDropdown === 'enquiry' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'enquiry'}>
                    <div>
                      <Link
                        to="/EnquiryForm"
                        className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <ChatDots size={18} className="me-2" /> Enquiry Form
                      </Link>
                      {/* <Link
                        to="/Marketer"
                        className="nav-link nav-link text-dark ps-3 py-2 d-flex align-items-center"
                      >
                        <Briefcase size={18} className="me-2" /> Marketer
                      </Link> */}
                    </div>
                  </Collapse>
                </>
              )}

              {/* Exam Management Dropdown */}
              {(user?.user_type !== 'parents')&& (
                <>
                  {' '}
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('examMarksheet')}
                  >
                    <span>
                      <FaPenAlt size={20} className="me-2" /> Exam Management
                    </span>
                    {openDropdown === 'examMarksheet' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'examMarksheet'}>
                    <div>
                                {(user?.user_type !== 'teacher') && (
          <>
                      <Link
                        to="/ExamSheet"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <FaClipboardList size={18} className="me-2" />
                        Exams
                      </Link>
             
          <Link
                        to="/ExamMarksheet"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <FaFileInvoice size={18} className="me-2" />
                        View Marksheet
                      </Link>
</>
                       )}
                    {(user?.user_type === "teacher" || user?.user_type === "admin" ) &&(
                      <Link
                        to="/AddExamResult"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <FaGraduationCap size={18} className="me-2" />
                        Create Marksheet
                      </Link>
                    )}
                     
                    </div>
                  </Collapse>
                </>
              )}

              {/* Change Password */}

            {user?.user_type === 'teacher' && (
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center"
                  onClick={() => (window.location.href = '/ChangePassword')}
                >
                  <span className='d-flex align-items-center'>
                  <FaUnlockAlt size={20} className="me-2" /> Change Password
                  </span>
                </Button>
              )}

              {(user?.user_type !== 'teacher' &&  user?.user_type !== 'parents') && (
                <>
                
              {/* Certificate Dropdown */}
              <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown('certificate')}
              >
                <span>
                  <Award size={20} className="me-2" /> Certificate
                </span>
                {openDropdown === 'certificate' ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </Button>
              <Collapse in={openDropdown === 'certificate'}>
                <div>
                  <Link
                    to="/Certificate"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <Award size={18} className="me-2" /> Generate Certificate
                  </Link>
                   {/* <Link
                    to="/Transfer/Certificate"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <Award size={18} className="me-2" /> Generate TC
                  </Link> */}
                </div>
              </Collapse>

</>
              )}
              {/* Student Promotion Dropdown */}
              {/* <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown('studentPromotion')}
              >
                <span>
                  <ClipboardData size={20} className="me-2" /> Student Promotion
                </span>
                {openDropdown === 'studentPromotion' ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </Button>
              <Collapse in={openDropdown === 'studentPromotion'}>
                <div>
                  <Link
                    to="/StudentPromotion"
                    className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                  >
                    <ClipboardData size={18} className="me-2" /> Promote Student
                  </Link>
                </div>
              </Collapse> */}

              {(user?.user_type !== 'teacher' && user?.user_type !== "parents") && (
                <Button
                  variant="light"
                  className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                  onClick={() => (window.location.href = '/Settings')}
                >
                  <div className="d-flex align-items-center">
                    <Settings size={20} className="me-2" />
                    <span>Settings</span>
                  </div>
                </Button>
              )}

               {user?.user_type === 'parents' && (
                   <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    onClick={() => (window.location.href = '/Student/List')}
                  >
                    <div className="d-flex align-items-center">
                      <FaUser size={20} className="me-2" />
                      <span>Student's Profile</span>
                    </div>
                  </Button> 
                 )} 
                  {user?.user_type === "parents" && (
                  <>
                  <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                    onClick={() => toggleDropdown('support')}
                  >
                    <span>
                      <QuestionCircle size={20} className="me-2" /> Support
                    </span>
                    {openDropdown === 'support' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'support'}>
                    <div>
                      <Link
                        to="/Raise-Query"
                        className="nav-link nav-link text-dark ps-5 py-2 d-flex align-items-center"
                      >
                        <QuestionCircle size={18} className="me-2" />
                        Raise Query
                      </Link>
                    </div>
                  </Collapse>
                  </>
                  )}
                

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="light"
                    className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    onClick={() => (window.location.href = '/Student/Course')}
                  >
                    <div className="d-flex align-items-center">
                      <FaBookOpen size={20} className="me-2" />
                      <span>Course</span>
                    </div>
                  </Button> */}
                {/* )} */}
            </Nav>

            {/* Logout Button at Bottom */}
            <Button
              // as={Link}
              // to="/LoginSignup"
              variant="primary"
              className="w-100"
              style={{ marginTop: '1rem' }}
              onClick={() => {
                console.log('Logout button clicked')

                logout()
              }}
            >
              <BoxArrowRight size={20} className="me-2" /> Logout
            </Button>
          </Container>
        </Navbar>
      </div>
    </>
  )
}
